export { default as Img200 } from './processed/200/16_9.jpg';
export { default as Img400 } from './processed/400/16_9.jpg';
export { default as Img600 } from './processed/600/16_9.jpg';
export { default as Img800 } from './processed/800/16_9.jpg';
export { default as Img1000 } from './processed/1000/16_9.jpg';
export { default as Imgthumb } from './processed/thumb/16_9.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/16_9.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/16_9.jpg';
export const ImgData = { width: 650, height: 366, ratio: 0.563076923076923, orientation: 'landscape' };
export const colors = {
  "Muted": {
    "_rgb": [
      132,
      132,
      132
    ],
    "_population": 2,
    "_hsl": [
      0,
      0,
      0.5176470588235295
    ]
  },
  "LightMuted": {
    "_rgb": [
      188,
      188,
      188
    ],
    "_population": 6,
    "_hsl": [
      0,
      0,
      0.7372549019607844
    ]
  },
  "DarkMuted": {
    "_rgb": [
      52,
      52,
      52
    ],
    "_population": 1,
    "_hsl": [
      0,
      0,
      0.20392156862745098
    ]
  },
  "Vibrant": {
    "_rgb": [
      0,
      0,
      0
    ]
  }
};



// WEBPACK FOOTER //
// ./src/content/images/16_9.js